import {createFileRoute, Navigate} from "@tanstack/react-router";
import {useSelf} from "../../agent/useSelf.ts";
import {Alert} from "@mui/joy";
import {useTranslation} from "react-i18next";
import {SuspenseDialog} from "../../components/SuspenseDialog.tsx";
import {defaultInspectionSettings} from "../../inspector/navi.tsx";

// it's essential to keep authenticated at all times, or you mess up setlist
// feed functions. you can safely redirect to here, but not ../index.
function AuthedSwitchboard() {
    const {t} = useTranslation();
    const {data: myself, isSuccess: isSelfSuccess} = useSelf();
    if (!isSelfSuccess) {
        return <SuspenseDialog message={t("loadingSelf")}/>;
    }

    if (myself.canAdmin) {
        return <Navigate to="/upload/shinwa-job" replace={true}/>
    }
    if (myself.canDrive) {
        return <Navigate to="/driver/schedule" replace={true}/>
    }
    if (myself.admitterFor) {
        return <Navigate to="/venue/$id/gate" params={{id: myself.admitterFor.id}} replace={true}/>
    }
    const supervisorFor = myself.supervisorFor;
    if (supervisorFor) {
        return <Navigate to="/venue/$id/supervise/bundle" params={{id: supervisorFor.id}} replace={true}/>
    }
    const inspectorFor = myself.inspectorFor;
    if (inspectorFor) {
        return <Navigate to="/venue/$id/inspect/bundle" params={{id: inspectorFor.id}}
                         search={defaultInspectionSettings} replace={true}/>
    }
    return <Alert variant="solid" color="danger">nothing for me to do</Alert>;
}

export const Route
    = createFileRoute("/_auth/")({
    component: AuthedSwitchboard,
});

